/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Skill_TierInputs */

const th_skill_tier = /** @type {(inputs: Skill_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ระดับ`)
};

const en_skill_tier = /** @type {(inputs: Skill_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Level`)
};

const ja_skill_tier = /** @type {(inputs: Skill_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レベル`)
};

const zh_skill_tier = /** @type {(inputs: Skill_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`水平`)
};

const es_skill_tier = /** @type {(inputs: Skill_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nivel`)
};

const pt_skill_tier = /** @type {(inputs: Skill_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nível`)
};

const id_skill_tier = /** @type {(inputs: Skill_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tingkat`)
};

const fr_skill_tier = /** @type {(inputs: Skill_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niveau`)
};

const tl_skill_tier = /** @type {(inputs: Skill_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antas`)
};

const vi_skill_tier = /** @type {(inputs: Skill_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trình độ`)
};

const ko_skill_tier = /** @type {(inputs: Skill_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`수준`)
};

const de_skill_tier = /** @type {(inputs: Skill_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niveau`)
};

const ru_skill_tier = /** @type {(inputs: Skill_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Уровень`)
};

const tr_skill_tier = /** @type {(inputs: Skill_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seviye`)
};

const it_skill_tier = /** @type {(inputs: Skill_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Livello`)
};

const pl_skill_tier = /** @type {(inputs: Skill_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poziom`)
};

const uk_skill_tier = /** @type {(inputs: Skill_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рівень`)
};

const hi_skill_tier = /** @type {(inputs: Skill_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्तर`)
};

const ar_skill_tier = /** @type {(inputs: Skill_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المستوى`)
};

const ms_skill_tier = /** @type {(inputs: Skill_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tahap`)
};

const bn_skill_tier = /** @type {(inputs: Skill_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`স্তর`)
};

const zh_tw2_skill_tier = /** @type {(inputs: Skill_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`層級`)
};

const zh_hk2_skill_tier = /** @type {(inputs: Skill_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`層級`)
};

const ur_skill_tier = /** @type {(inputs: Skill_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`درجہ`)
};

const fa_skill_tier = /** @type {(inputs: Skill_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سطح`)
};

const sw_skill_tier = /** @type {(inputs: Skill_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiwango`)
};

const nl_skill_tier = /** @type {(inputs: Skill_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niveau`)
};

/**
* | output |
* | --- |
* | "Level" |
*
* @param {Skill_TierInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const skill_tier = /** @type {((inputs?: Skill_TierInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Skill_TierInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_skill_tier(inputs)
	if (locale === "ja") return ja_skill_tier(inputs)
	if (locale === "zh") return zh_skill_tier(inputs)
	if (locale === "es") return es_skill_tier(inputs)
	if (locale === "pt") return pt_skill_tier(inputs)
	if (locale === "id") return id_skill_tier(inputs)
	if (locale === "fr") return fr_skill_tier(inputs)
	if (locale === "tl") return tl_skill_tier(inputs)
	if (locale === "vi") return vi_skill_tier(inputs)
	if (locale === "ko") return ko_skill_tier(inputs)
	if (locale === "de") return de_skill_tier(inputs)
	if (locale === "ru") return ru_skill_tier(inputs)
	if (locale === "tr") return tr_skill_tier(inputs)
	if (locale === "it") return it_skill_tier(inputs)
	if (locale === "pl") return pl_skill_tier(inputs)
	if (locale === "uk") return uk_skill_tier(inputs)
	if (locale === "hi") return hi_skill_tier(inputs)
	if (locale === "ar") return ar_skill_tier(inputs)
	if (locale === "ms") return ms_skill_tier(inputs)
	if (locale === "bn") return bn_skill_tier(inputs)
	if (locale === "zh-TW") return zh_tw2_skill_tier(inputs)
	if (locale === "zh-HK") return zh_hk2_skill_tier(inputs)
	if (locale === "ur") return ur_skill_tier(inputs)
	if (locale === "fa") return fa_skill_tier(inputs)
	if (locale === "sw") return sw_skill_tier(inputs)
	if (locale === "nl") return nl_skill_tier(inputs)
	return en_skill_tier(inputs)
});